import { appRoutes } from '@clearverify/constants';

import { UserRole } from 'src/api';
import { ReactRouteAccessKey } from 'src/constants/reactRouter';
import { BusinessRole } from 'src/constants/user';
import {
  AuthWelcomePage,
  ForgotPasswordPage,
  LoginPage,
  LogoutPage,
  ResetPasswordPage,
  SetupMfaPage,
  SetupPaymentMethodsPage,
  SignUpVerifier,
  SignupByInvitePage,
  SignupConsumerByPeoPage,
  SignupConsumerPage,
  SignupPageLegacyRedirect,
  SsoCallbackPage,
} from 'src/pages/auth';
import { SignupConsumerByPeoPayrollProviderPage } from 'src/pages/auth/SignupConsumerByPeoPayrollProviderPage';
import type { RouteProps } from 'src/types/router';

import { AuthOutletWrap } from './components';

const ROUTES: RouteProps[] = [
  {
    index: true,
    element: <AuthWelcomePage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.auth.login,
    element: <LoginPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.auth.logout,
    element: <LogoutPage />,
    accessRoles: [ReactRouteAccessKey.anyAuthorized],
  },
  {
    path: appRoutes.auth.passwordReset,
    element: <ForgotPasswordPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.auth.passwordResetRequeset,
    element: <ResetPasswordPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.auth.signup,
    element: <SignupByInvitePage />,
    accessRoles: [ReactRouteAccessKey.inherit, BusinessRole.VerifierAdmin],
  },
  {
    path: appRoutes.auth.verifierSignup,
    element: <SignUpVerifier />,
    accessRoles: [ReactRouteAccessKey.inherit, BusinessRole.VerifierAdmin],
  },
  {
    path: appRoutes.auth.signupEmployee,
    element: <SignupConsumerPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.auth.signupEmployeePeo,
    element: <SignupConsumerByPeoPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.auth.signupEmployeePeoPayrollProvider,
    element: <SignupConsumerByPeoPayrollProviderPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.auth.signupEmployeeLegacy,
    element: <SignupPageLegacyRedirect />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.auth.signupEmployeePeoLegacy,
    element: <SignupPageLegacyRedirect />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.auth.signupEmployeePeoPayrollProviderLegacy,
    element: <SignupPageLegacyRedirect />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
  {
    path: appRoutes.auth.setupMfa,
    element: <SetupMfaPage />,
    accessRoles: [ReactRouteAccessKey.anyAuthorized],
  },
  {
    path: appRoutes.auth.setupPaymentMethods,
    element: <SetupPaymentMethodsPage />,
    accessRoles: [ReactRouteAccessKey.anyAuthorized],
  },
  {
    path: appRoutes.auth.ssoCallback,
    element: <SsoCallbackPage />,
    accessRoles: [ReactRouteAccessKey.inherit],
  },
];

export const AUTH_ROUTE: RouteProps = {
  path: appRoutes.auth.index,
  element: <AuthOutletWrap />,
  childRoutes: ROUTES,
  accessRoles: [UserRole.Guest],
};
